// extracted by mini-css-extract-plugin
module.exports = {"viewports":"\"../../../../viewports.css\"","desktop":"1024px","story-editor-info-bar":"info-bar_story-editor-info-bar__1ljWT"};